import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <g clipPath="url(#clip0_8311_9074)">
                <path
                    d="M16.3701 14H15.5801L15.3001 13.73C16.2801 12.59 16.8701 11.11 16.8701 9.5C16.8701 5.91 13.9601 3 10.3701 3C6.78012 3 3.87012 5.91 3.87012 9.5C3.87012 13.09 6.78012 16 10.3701 16C11.9801 16 13.4601 15.41 14.6001 14.43L14.8701 14.71V15.5L19.8701 20.49L21.3601 19L16.3701 14ZM10.3701 14C7.88012 14 5.87012 11.99 5.87012 9.5C5.87012 7.01 7.88012 5 10.3701 5C12.8601 5 14.8701 7.01 14.8701 9.5C14.8701 11.99 12.8601 14 10.3701 14Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_8311_9074">
                    <rect width="24" height="24" fill="white" transform="translate(0.870117)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(Search);
